import { CONFIG } from '@/config';
import {
  ApiProviderUnauthenticated,
  AppMessagingProvider,
  AuthProvider,
  WebPortalManagerTheme,
  ToastQueueProvider,
} from '@idu-nightlife/ui-kit';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import type { Locale } from 'date-fns/locale';
import { enAU } from 'date-fns/locale/en-AU';
import { enGB } from 'date-fns/locale/en-GB';
import { enUS } from 'date-fns/locale/en-US';
import { SnackbarProvider } from 'notistack';
import React from 'react';

function getBrowserLocale(): Locale {
  const localeMap: Record<string, Locale> = {
    'en-US': enUS,
    'en-AU': enAU,
    'en-GB': enGB,
  };

  return localeMap[navigator.language] || localeMap[navigator.language.split('-')[0]] || enAU;
}

export function AppProviders(props: Readonly<{ children: React.ReactNode }>) {
  return (
    <ThemeProvider theme={WebPortalManagerTheme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getBrowserLocale()}>
        <AppMessagingProvider mode="parent">
          <ApiProviderUnauthenticated baseUrl={CONFIG.API_BASE_URL} appName="manager">
            <AuthProvider>
              <ToastQueueProvider>
                <SnackbarProvider maxSnack={3}>{props.children}</SnackbarProvider>
              </ToastQueueProvider>
            </AuthProvider>
          </ApiProviderUnauthenticated>
        </AppMessagingProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
